import type { BlockComponentStateId, BlockComponentType } from '../../types/block';
import type { SlotType } from '../../types/slot';
import type { StyleObject } from '../../types/styleObject';
import type { FileType } from '../FileUpload/types';
import type { TooltipPlacement } from '../Typography/types';

export enum ImageSrcEnum {
  URL = 'URL',
  UPLOAD = 'UPLOAD',
}

export type AddOns = {
  tooltip?: {
    text?: string;
    placement?: TooltipPlacement;
    width?: string | { custom: string };
  };
};

export type ImageContent = {
  /**
   * The URL of the image to be displayed.
   * @deprecated to be removed, these are kept for backward compatibility
   */
  src?: string;
  /**
   * A textual description of the image.
   * @deprecated to be removed, these are kept for backward compatibility
   */
  alt?: string;
  addOns?: AddOns;
  data?: {
    /**
     * The type of the image source i.e URL or UPLOAD
     */
    type: ImageSrcEnum;
    src?: string;
    /**
     * The details of the uploaded image.
     */
    uploadDetails?: FileType;
    alt?: string;
  };
};

type Appearance = {
  objectFit:
    | 'object-contain'
    | 'object-cover'
    | 'object-fill'
    | 'object-none'
    | 'object-scale-down';
  styles?: Pick<
    StyleObject,
    | 'padding'
    | 'margin'
    | 'height'
    | 'width'
    | 'minHeight'
    | 'minWidth'
    | 'maxHeight'
    | 'maxWidth'
    | 'layout'
    | 'visibility'
    | 'borderRadius'
  >;
};

export type ImageSlots = {
  /**
   * Fallback slot to be displayed when image fails to load
   */
  fallback?: SlotType;
};

export type ImageComponentType = BlockComponentType<'Image', ImageContent, Appearance, ImageSlots>;

export type ImageBlockStateType = Pick<
  ImageComponentType,
  'appearance' | 'content' | 'componentType'
> & {
  state: {
    isOpenInMediaViewer: boolean;
  };
} & BlockComponentStateId;
